// extracted by mini-css-extract-plugin
export var row = "_vo-0";